@charset "UTF-8";

/* src/app/modules/portal/components/lastDataSourceRefresh/run-task-button/run-task-button.component.scss */
\b4  :host {
  display: flex;
  flex-direction: column;
  align-items: center;
}
\b4  :host sh-text {
  padding-left: 1rem;
}
.top-row {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
[screen-phone] :host-context .top-row {
  flex-direction: column;
}
.row {
  flex-direction: row;
  display: flex;
  gap: 1rem;
  align-items: center;
  --sh-spinner-width-s: 24px;
  --sh-spinner-height-s: 24px;
}
.row sh-spinner {
  max-width: 24px;
  width: 24px;
}
.row sh-icon {
  max-width: 24px;
  width: 24px;
}
[error] {
  color: rgb(var(--functional-red));
}
[debug] {
  display: none;
}
[multitask] {
  display: none;
}
[singletask] {
  display: initial;
}
.button {
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.button sh-button {
  max-width: initial;
}
.button .spinner {
  opacity: 0;
  position: absolute;
  left: 0.75rem;
  top: 0.2rem;
  margin: initial;
  --sh-spinner-width-s: 1.5rem;
  --sh-spinner-height-s: 1.5rem;
  --sh-spinner-border-width: 0.2rem;
}
.button[showSpinner] sh-button {
  padding-left: 44px;
}
.button[showSpinner] .spinner {
  opacity: 1;
}
/*# sourceMappingURL=run-task-button.component.css.map */
